import { useContext, useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { AuthContext } from 'shared/legacy/contexts/AuthContext';
import { useCurrentUserQuery } from 'shared/legacy/hooks/useCurrentUserQuery';
import { updateExtensionSettings } from 'utils/updateExtentionSettings';
import { BrowserExtensionInfoStatus, useBrowserExtensionStatusQuery } from './useBrowserExtensionStatusQuery';

export const useUpdateExtensionSettings = () => {
  const { data: browserExtensionStatus } = useBrowserExtensionStatusQuery();
  const { data: currentUser } = useCurrentUserQuery();
  const { activeToken } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (browserExtensionStatus.status === BrowserExtensionInfoStatus.Active && currentUser && activeToken) {
      updateExtensionSettings();
    }
  }, [browserExtensionStatus.status, !!currentUser, activeToken, location.pathname]);
};
